import { render } from "./LiveRacesTable.vue?vue&type=template&id=74a9a2ba&ts=true"
import script from "./LiveRacesTable.vue?vue&type=script&lang=ts"
export * from "./LiveRacesTable.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__